/* eslint-disable */
export default {
	NODE_ENV: 'staging',
	API_URL: 'https://staging.distribution.lr-lab.com/api-staging',
	AUTH_URL: 'https://staging.distribution.lr-lab.com/api-staging/auth/login',
	LR_CLOUD_URL: 'http://staging.cloud.lr-lab.com'
}
/* eslint-enable */
